/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LocationAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Location from './Location/index'
import React from 'react'
import Tysiav2Location from 'DesignSystem/Svgs/Tysiav2Location/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function LocationAction({
  children,
  viewPath = "/App/Account/Topbar/Options/Content/LocationAction"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<button
  data-testid="LocationAction.Horizontal"
  data-view-path={viewPath}
 onClick={() => setFlowTo("/App/ChooseLocation")}
 {...isHoveredBind}
 style={{'--mr-1-Z23pjbx': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--ml-2-Z23pjbx': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pt-3-Z23pjbx': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-4-Z23pjbx': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-5-Z23pjbx': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-6-Z23pjbx': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-7-Z23pjbx': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-8-Z23pjbx': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-9-Z23pjbx': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-10-Z23pjbx': isHovered ? dtColorsNeutral200 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<Location
  viewPath={`${viewPath}/Location`}
 cursor="pointer"
 size="xmedium"
 color={dtColorsNeutral900}
/>
<Tysiav2Location
  viewPath={`${viewPath}/Tysiav2Location`}
 marginLeft="auto"
 width={16}
 height={16}
 fill2={dtColorsNeutral400}
/>
</button>
{children}
</React.Fragment>)
}